import axios from 'axios';
import toast from 'react-hot-toast';

const axiosInstance = axios.create();

// Request Interceptor: Attach token to request headers
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);


// Response Interceptor: Handle 401 errors (Unauthorized)
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('userInfo');
            localStorage.removeItem('token');
            
            toast.error('Your session has expired. Please log in again.');            
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
